import { createSlice } from "@reduxjs/toolkit";

export const ScheduleTimeSlotDetailSlice = createSlice({
    name: "scheduleTimeSlotsDetail",
    initialState: {
        scheduleTimeSlotsDetail: null
    },
    reducers: {
        setScheduleTimeSlotDetail: (state, action) => {
            state.scheduleTimeSlotsDetail = action.payload;
        },
        clearScheduleTimeSlotDetail: (state, action) => {
            state.scheduleTimeSlotsDetail = null;
        }
    }
})

export const { setScheduleTimeSlotDetail, clearScheduleTimeSlotDetail } = ScheduleTimeSlotDetailSlice.actions;

export default ScheduleTimeSlotDetailSlice.reducer;